import { getLocalPersistedValue } from 'shared/utils/persisted-values';

// localStorage key a claimed kiosk id is persisted under (device config, survives tablet relaunches).
export const KIOSK_ID_STORAGE_KEY = 'kioskId';
// localStorage key for the admin-typed kiosk name, persisted alongside the id at claim time so
// the lock-screen chip can show it without depending on the (cached) dispensary query.
export const KIOSK_NAME_STORAGE_KEY = 'kioskName';

/**
 * Reads the persisted kiosk id, used to rehydrate `Cart.originKioskId` and by `CoreMenuLayout`
 * to decide whether the PIN screen is needed.
 *
 * The `typeof fn === 'function'` guard + try/catch is required: this runs in the `Cart`
 * constructor, and many marketplace test suites partially mock `persisted-values`, so a
 * throw/missing mock here must never break unrelated tests.
 */
export function getPersistedKioskId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return typeof getLocalPersistedValue === 'function' ? getLocalPersistedValue(KIOSK_ID_STORAGE_KEY, null) : null;
  } catch {
    return null;
  }
}

/**
 * Reads the persisted kiosk name. Same guards as `getPersistedKioskId` -- read during render on
 * the public lock screens.
 */
export function getPersistedKioskName(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return typeof getLocalPersistedValue === 'function' ? getLocalPersistedValue(KIOSK_NAME_STORAGE_KEY, null) : null;
  } catch {
    return null;
  }
}
